var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkLocationIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2949_26014)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2949_26014",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 9.18172V16.9367H29.5C31.15 16.9367 32.5 18.2867 32.5 19.9367V28.9367C32.5 30.5867 31.15 31.9367 29.5 31.9367H8.5C6.85 31.9367 5.5 30.5867 5.5 28.9367V13.9367C5.5 12.2867 6.85 10.9367 8.5 10.9367H14.5V9.18172C14.5 8.38672 14.815 7.62172 15.385 7.05172L17.935 4.50172C18.2152 4.22084 18.5957 4.06299 18.9925 4.06299C19.3893 4.06299 19.7698 4.22084 20.05 4.50172L22.615 7.06672C23.185 7.62172 23.5 8.38672 23.5 9.18172ZM8.5 28.9367H11.5V25.9367H8.5V28.9367ZM11.5 22.9367H8.5V19.9367H11.5V22.9367ZM8.5 16.9367H11.5V13.9367H8.5V16.9367ZM20.5 28.9367H17.5V25.9367H20.5V28.9367ZM17.5 22.9367H20.5V19.9367H17.5V22.9367ZM20.5 16.9367H17.5V13.9367H20.5V16.9367ZM17.5 10.9367H20.5V7.93672H17.5V10.9367ZM29.5 28.9367H26.5V25.9367H29.5V28.9367ZM26.5 22.9367H29.5V19.9367H26.5V22.9367Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2949_26014)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 36,
    height: 36,
    fill: "#495057"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2949_26014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.865234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkLocationIconSvg);
export default __webpack_public_path__ + "static/media/link-location-icon-svg.6edcbcdd.svg";
export { ForwardRef as ReactComponent };